import React from 'react'
import * as THREE from 'three'
import Superface from '../Superface'

export default class MaterialsGridMobile extends React.Component{

    
    
    constructor(props){
        super(props)
        this.frame = 0

        this.handleResize = this.handleResize.bind(this)
        // this.onMouseDown = this.onMouseDown.bind(this)
        // this.onMouseUp = this.onMouseUp.bind(this)
        
    }

    //
    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
    //

    componentWillMount(){
        
        // if( this.props.materialsImagesLoaded ){
        //     this.loadImages( this.props.materials )
        // }
        this.setState({
            ...this.state, mounted : false
        })
        // this.start()

    }

    // shouldComponentUpdate(){
    //     // return false
    // }

    componentDidMount() {
        Superface.setLoading(true)
		// window.addEventListener('mousemove', this.handleMouseMove)
		window.addEventListener('resize', this.handleResize)
       

    }

    componentWillReceiveProps(new_props){

    }
    
    componentWillUnmount(){
      
        if( this.timeoutResize )  window.clearTimeout( this.timeoutResize )
        if( this.timeoutMount )  clearTimeout( this.timeoutMount )
        window.removeEventListener('resize', this.handleResize)
      
    }

    //
    // ─── INIT 3D ────────────────────────────────────────────────────────────────────
    //

    increaseImagesLoaded(){
        this.imagesLoaded += 1
        if( this.imagesLoaded > this.imagesToLoad ){
            this.projectsReady()
        }
    }

    renderImages(){
        
        this.imagesLoaded = 0
        this.imagesToLoad = this.props.projects.length - 1
        
        
        // console.log(this.props.projects)
        return this.props.projects.map( (projet, i) => {
            const style = {
                textAlign : ( i % 2 === 0 ? 'left' : 'right'),
                width : '100%',
                paddingTop : ( i % 3 === 0 ? '5rem' : '10rem')
            }
            return (
                <div style={style} key={i} onClick={ () => { 
                    Superface.goTo( Superface.uri('projets') + '/' + projet.slug ) 
                    }} >
                    <img style={{display:'inline-block', width:'60%'}} onLoad={() => {this.increaseImagesLoaded()}} src={Superface.assetUrl(projet.thumb.path)} alt={"projet " + projet.name} />
                </div>
            )
        })
    }

    projectsReady(){
        Superface.setLoading(false)
        this.setState({
            ...this.state, mounted : true
        })
    }

    handleResize() {
        this.setState({ ... this.state })
    }
    
    //
    // ─── ANIMATE ────────────────────────────────────────────────────────────────────
    //
 
	render() {
        if( this.props.projects.length === 0 ) return <div></div>
        
		return (
            
            <div id="grid-mobile" style={{width:'100%', height:'100%', display:(this.state.mounted ? 'block' : 'none') }}>
            
                {this.renderImages()}
            
            </div>
		)
    }
    
}


// WEBPACK FOOTER //
// ./src/components/mobile_ProjectsGrid.js